module.exports = "pegasus/assets/header-card.png";